import { LmgService } from "../resource";

const BillingModule = {
  namespaced: true,
  state: {
    datas: [],
    datas_duedate : [],
    data: {},
    billing_status: [
      { ID: 1, Name: "จ่ายแล้ว" },
      { ID: 2, Name: "ยังไม่จ่าย" }
    ],
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATAS_DUEDATE(state, payload) {
      state.datas_duedate = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.BillingCreate(payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.BillingList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },


	async listBillingDuedate({ commit, state },payload) {
        const data = await LmgService.BillingReportList(payload);
		try {
			commit("SET_DATAS_DUEDATE", data.data.Data == null ? [] : data.data.Data);
		} catch (err) {
		  commit("SET_DATAS_DUEDATE", []);
		}
	  },



  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getDataDueDate(state) {
		return state.datas_duedate;
	},

    getBillingStatusNameWithAll(state){
      return [{ID:0, Name : "ทั้งหมด"},...state.billing_status];
    },
    getBillingStatusName( state ){
      var self = this;
      return function (id){
        let s =  state.billing_status.filter(f => {
          return f.ID == id;
        });
        return s.length == 0 ? 'Unknown' : s[0].Name
      }
    },
    
  }
};

export default BillingModule;
